import { enUS, es, ptBR } from "date-fns/locale";
import { usePatient } from "src/context/PatientProvider";

export const localeMap: Record<string, Locale> = {
  en: enUS,
  es: es,
  pt: ptBR,
};

export const usePatientLocale = () => {
  const language = usePatient((patient) => patient.profile.language);

  const locale = localeMap[language];

  return locale;
};
